import {
  useListAttributesQuery,
  useListEnvironmentsQuery,
  useListProductsQuery,
} from '~/modules/query/featureFlags';

import type { Reference } from '~/components/pages/feature-flags/common';

/** Environments, products and attributes, read together: the section page and every record page need all three. */
export const useReference = () => {
  const environments = useListEnvironmentsQuery();
  const products = useListProductsQuery();
  const attributes = useListAttributesQuery();
  const reference: Reference = {
    environments: environments.data ?? [],
    products: products.data ?? [],
    attributes: attributes.data ?? [],
    pending: environments.isFetching || products.isFetching || attributes.isFetching,
  };
  return {
    reference,
    loaded: !!environments.data && !!products.data && !!attributes.data,
    error: environments.error ?? products.error ?? attributes.error,
    refetch: () => {
      environments.refetch();
      products.refetch();
      attributes.refetch();
    },
  };
};
